<template>
    <app-layout class="main">
        <div class="row panel-container">
            <panel>
                <h2 slot="header">Rediģēt profilu</h2>

                <input type="file" id="fileUpload" ref="fileUpload" v-show="false" @change="onFileChange($event)"/>

                <form ref="userForm" @submit.prevent="onUserFormSubmit()">
                    <div class="row column avatar-input-container">
                        <div v-if="model.file && model.avatar" class="avatar-preview clickable" @click="changeAvatar()" :style="{ backgroundImage: 'url(' + model.avatar.full_url + ')' }"></div>
                        <img v-else :src="userAvatarSrc" class="avatar clickable" @click="changeAvatar()"/>

                        <button type="button" class="button hollow secondary small" @click.prevent="changeAvatar()">Mainīt bildi</button>
                        <button type="button" class="button hollow secondary small" @click.prevent="removeAvatar()">Dzēst bildi</button>
                    </div>

                    <div class="row">
                        <div class="column small-12 medium-6">
                            <label :class="{ 'is-invalid-label': errors.has('first_name') }">Vārds
                                <input type="text" name="first_name" id="first_name" v-model="model.first_name" v-validate="'required|max:255'" :class="{ 'is-invalid-input': errors.has('first_name') }"/>
                                <span class="form-error is-visible" v-if="errors.has('first_name')">{{ errors.first('first_name') }}</span>
                            </label>
                        </div>
                        <div class="column small-12 medium-6">
                            <label :class="{ 'is-invalid-label': errors.has('last_name') }">Uzvārds
                                <input type="text" name="last_name" id="last_name" v-model="model.last_name" v-validate="'required|max:255'" :class="{ 'is-invalid-input': errors.has('first_name') }"/>
                                <span class="form-error is-visible" v-if="errors.has('last_name')">{{ errors.first('last_name') }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="column small-12 medium-6">
                            <label :class="{ 'is-invalid-label': errors.has('pseudonym') }">Pseidonīms
                                <input type="text" name="last_name" id="pseudonym" v-model="model.pseudonym" v-validate="'required|max:255'" :class="{ 'is-invalid-input': errors.has('pseudonym') }"/>
                                <span class="form-error is-visible" v-if="errors.has('pseudonym')">{{ errors.first('pseudonym') }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="column small-12">
                            <label :class="{ 'is-invalid-label': errors.has('school_id') }">Skola
                                <v-select v-model="model.school"
                                        :options="schools"
                                        @search="findSchools"
                                        label="title"
                                        :closeOnSelect="true"
                                        :filterable="false"
                                        placeholder="Izvēlies skolu...">
                                    <span slot="no-options">Nav rezultātu.</span>
                                </v-select>
                                <span class="form-error is-visible" v-if="errors.has('school_id')">{{ errors.first('school_id') }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="row column">
                        <label>Īss apraksts
                            <textarea v-model="model.description" rows="5" v-validate="'max:500'"></textarea>
                        </label>
                    </div>

                    <div class="row column">
                        <label :class="{ 'is-invalid-label': errors.has('newsletter') }">
                            <input type="checkbox" v-model="model.newsletter" name="newsletter" id="newsletter"/>Piekrītu saņemt jaunumus no FIZMIX</router-link>
                        </label>
                        <span class="form-error is-visible" v-if="errors.has('newsletter')">{{ errors.first('newsletter') }}</span>
                    </div>
                </form>

                <template slot="footer">
                    <button type="button" class="button success" @click.prevent="submitUserForm()">Saglabāt</button>
                </template>

            </panel>
        </div>
    </app-layout>
</template>


<script>
import AppLayout from '../layouts/AppLayout'
import Panel from '../components/Panel'
import VueSelect from 'vue-select'
import { mapGetters } from 'vuex'
import schools from '../api/schools'

export default {

    created() {
        Object.assign(this.model, { ...this.user });
    },

    data: function () {
        return {
            model: {
                id: null,
                first_name: null,
                last_name: null,
                pseudonym: null,
                school: null,
                school_id: null,
                description: null,
                newsletter: false,
                avatar_id: null,//Holds existing foreign key
                avatar: null,//Holds existing avatar object
                file: null,//Holds new avatar file for uploading
            },

            schools: []
        }
    },

    methods: {
        changeAvatar(ev) {
            this.$el.querySelector('#fileUpload').click();
        },

        onFileChange(event) {
            this.model.file = event.target.files[0];

            // Preview selected image
            const reader = new FileReader();
            reader.onload = e => {
                this.model.avatar = this.model.avatar ? this.model.avatar : {};
                this.model.avatar.full_url = e.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        },

        removeAvatar() {
            this.model.avatar_id = null;
            this.model.avatar = null;
            this.model.file = null;
        },

        submitUserForm() {
            this.$validator.validateAll()
                .then(success => {
                    if (!success) return;
                    this.onUserFormSubmit();
                });
        },

        onUserFormSubmit() {
            this.model.school_id = this.model.school ? this.model.school.id : null;
            if (this.model.newsletter === null) {
                this.model.newsletter = false;
            }
            this.$store.dispatch('updateUser', { ...this.model } )
                .then(response => this.$router.push({ name: 'profile' }))
                .catch(error => console.log(error.response.data));
            //TODO implement errors
        },

        async findSchools(search, loading) {
            loading(true);
            this.schools = await schools.get({ s: search }).then(response => response.data);
            loading(false);
        },
    },

    computed: {

        ...mapGetters(['user']),

        userAvatarSrc: function () {
            return this.model.avatar ? _.get(this.model.avatar, 'sizes.icon.full_url') : require('../../images/avatar-add.svg');
        }
    },

    watch: {
        user: function (val, oldVal) {
            Object.assign(this.model, { ...this.user });
        },
    },

    components: { Panel, AppLayout, 'v-select': VueSelect }
}
</script>


<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .avatar,
    .avatar-preview {
        width: 86px;
        height: 86px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
    }

    .avatar-preview {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
    }

    .avatar-input-container {
        margin-bottom: $form-spacing;

        > * {
            margin-bottom: 0;

            &:not(:last-child) {
                margin-right: $form-spacing;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/MyProfileEdit.vue